import React from 'react';
import { Spin, Typography } from 'antd';
import InfoCard from '../../common/InfoCard/InfoCard';
import { CardChangeButton } from '../../../../../components/Card';
import AddInfoBlock from '../AddInfoBlock/AddInfoBlock';
import PhoneNumber from '../../../../../components/PhoneNumber/PhoneNumber';
import styles from './HeadOfHouse.module.scss';

const { Paragraph } = Typography;

const HeadOfHouse = ({
  houseHead = {},
  className,
  loading,
  onChangeButtonClick,
}) => {
  return (
    <InfoCard
      title="Председатель совета дома"
      action={
        !Object.keys(houseHead).length ? null : (
          <CardChangeButton onClick={onChangeButtonClick} />
        )
      }
      className={className}
    >
      <Spin spinning={loading}>
        {!Object.keys(houseHead).length ? (
          <AddInfoBlock onAddBtnClick={onChangeButtonClick} />
        ) : (
          <>
            <Typography className={styles.name}>
              <Paragraph>{houseHead.name}</Paragraph>
            </Typography>
            <Typography className={styles.contacts}>
              {houseHead.phone && (
                <PhoneNumber
                  className={styles.tel}
                  phoneNumber={houseHead.phone}
                  name={houseHead.name}
                />
              )}
              {houseHead.email && (
                <Paragraph className={styles.email}>
                  {houseHead.email}
                </Paragraph>
              )}
            </Typography>
          </>
        )}
      </Spin>
    </InfoCard>
  );
};

export default HeadOfHouse;
